import index from '../components/index'
import form from '../components/children/topics/form';
// import Step from '../components/children/step';
import StepCreate from '../components/children/steps/step-create';
import StepEdit from '../components/children/steps/step-edit';
import Guide from '../components/guide';
import store from '@/store'

export default [
    {
        path: '/guide',
        component: index,
        meta: { auth: true },
        children:[
            {
                path: '',
                name:"guide",
                component: Guide
            },
            {
                path: '/topics/create',
                component: form,
                name: 'topics.create',
                meta: { 
                    auth: true,
                    title:'Create Topic' 
                },
                beforeEnter: (to, from, next) => {
                    if (store.state.auth.roles.includes('superadmin')) {
                        next()
                    } else {
                        next({
                            name: "guide"
                        })
                        return
                    }
                },
            },
            {
                path: '/topics/:id/edit',
                component: form,
                name: 'topics.edit',
                meta: { 
                    auth: true,
                    title:'Edit Topic' 
                },
                beforeEnter: (to, from, next) => {
                    if (store.state.auth.roles.includes('superadmin')) {
                        next()
                    } else {
                        next({
                            name: "guide"
                        })
                        return
                    }
                },
            },
            {
                path: '/steps/:id/edit',
                name:"steps.edit",
                component: StepEdit
            },
            {
                path: '/steps/create',
                name:"steps.create",
                component: StepCreate
            }
        ]
    },
]